/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import Pagination from "./Pagination.container";

export default Pagination;
